var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconUser = function SvgIconUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-user_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M634.526 613.086c-5.564-1.81-40.682-17.644-18.739-84.363h-.304c57.199-58.902 100.918-153.742 100.918-247.079 0-143.537-95.459-218.75-206.374-218.75-110.987 0-205.897 75.213-205.897 218.75 0 93.715 43.479 188.929 101.02 247.694 22.422 58.834-17.681 80.676-26.075 83.748-116.173 42.009-252.447 118.59-252.447 194.18v28.327C126.628 938.586 326.31 962 511.117 962c185.077 0 382.237-23.414 382.237-126.407v-28.326c0-77.877-136.956-153.843-258.828-194.181z",
    fill: "#676767"
  })));
};

export default SvgIconUser;